<ng-container *ngIf="open">
    <cms-overlay [zIndex]="1050" (backdropClick)="onBackdropClick($event)"></cms-overlay>
    <aside class="cms-drawer mantis-theme" [attr.id]="drawerId" [class.show]="open" role="dialog" aria-modal="true">
        <header class="cms-drawer__header">
            <div class="cms-drawer__header-text">
                <h2 class="cms-drawer__title">
                    <ng-content select="[cmsDrawerHeader]"></ng-content>
                </h2>
                <p class="cms-drawer__subtitle">
                    <ng-content select="[cmsDrawerSubtitle]"></ng-content>
                </p>
                <div class="cms-drawer__tags">
                    <ng-content select="[cmsDrawerTags]"></ng-content>
                </div>
            </div>
            <button type="button" class="cms-drawer__close" (click)="onCloseClick()" aria-label="Close">
                <img src="assets/common/ic_x.svg" alt="" width="20" height="20" />
            </button>
        </header>

        <div class="cms-drawer__body">
            <ng-content></ng-content>
        </div>

        <footer class="cms-drawer__footer">
            <ng-content select="[cmsDrawerFooter]"></ng-content>
        </footer>
    </aside>
</ng-container>
